import { type FC } from "react"

import { useTranslation } from "react-i18next"
import { useRecoilState, useResetRecoilState } from "recoil"
import styled from "styled-components"

import {
  calculatedUtilityRateState,
  useEffectiveUtilityRate,
} from "~/containers/Proposal/state/utility-costs-and-savings/utility-costs-and-savings-state"

import { ReactComponent as ResetIcon } from "@svg/reset.svg"

import { NewTooltip, NumberInput, NumberInputWrapper } from "./ui"

const UTILITY_RATE_INPUT_ID = `utilityRateInput`

export const UtilityRateInput: FC<{
  disabled?: boolean
  useOverride?: boolean
}> = ({ disabled = false, useOverride }) => {
  const { t } = useTranslation()
  const [, setUtilityRate] = useRecoilState(calculatedUtilityRateState)
  const resetUtilityRate = useResetRecoilState(calculatedUtilityRateState)
  const { effectiveUtilityRate } = useEffectiveUtilityRate()

  return (
    <div>
      <UtilityRateWrapper>
        <NumberInputWrapper>
          <NewTooltip
            messageStyle={{ maxWidth: `400px` }}
            message={`The selected utility uses contracted rates. They can be edited in the “Utility Company and Rate” menu.`}
            disabled={!disabled}
            wrapperStyle={{
              gap: `10px`,
              flexDirection: `column`,
              display: `flex`,
            }}
          >
            <div data-role="label-wrapper">
              <label>{t(`utilityRate`)} ($/kWh)</label>
              {useOverride === true && !disabled ? (
                <button
                  title="reset"
                  onClick={(v) => {
                    resetUtilityRate()
                  }}
                >
                  <ResetIcon />
                </button>
              ) : null}
            </div>
            <NumberInput
              value={effectiveUtilityRate}
              setValue={(v) => {
                setUtilityRate(v ?? effectiveUtilityRate)
              }}
              decimalPlaces={2}
              min={0}
              disabled={disabled}
              id={UTILITY_RATE_INPUT_ID}
              testId="utility-rate"
            />
          </NewTooltip>
        </NumberInputWrapper>
      </UtilityRateWrapper>
    </div>
  )
}

export const UtilityRateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100px;
  width: fit-content;
  padding: 0;
  [data-role="label-wrapper"] {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 16px;
    width: 130px;
    gap: 5px;
  }
  button {
    svg {
      stroke: var(--grey-medium);
      width: 16px;
      height: 16px;
      padding: 0;
      margin: 0;
      cursor: pointer;
    }
  }
`
